/* ---------------------------------
Date Utilities
--------------------------------- */

export const formatDate = (
  ISOdateString: string | undefined | null
): string => {
  if (!ISOdateString) return ''

  const date = new Date(ISOdateString)
  return new Intl.DateTimeFormat('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date)
}
